import * as React from "react";
import { EcommFacetProvider, ProductImageGallery, ReadyReaderEcommContent, useProductDetailSlots, ProductDetailFullWidth, FrameMeasurements, StickyMobileCtaAndPrice, ReadyReaderCTA, ProductDetailStack, ProductDetailDescription, ProductDetailFeatures, ProductDetailDisclaimer, ProductDetailDrawerStack, ProductDetailSpecification, ProductDetailManufacturerDrawer, ProductDetailReviewsDrawer, mapServerToReadyReaderProduct, getReadyReaderBySlug } from "@grandvisionhq/fun-products";
import { P as ProductPageLayoutBase, a as ProductPageBase, e as defaultReadyReaderFacetConfig, f as fetchProductConfigBySlug, h as handleValidations } from "../../ProductPageLayoutBase.js";
import { b as defaultReadyReadersFlatFacetConfig } from "../../default-flat-facet-configs.js";
import { CmsComponentSlot } from "@grandvisionhq/bloomreach";
const EcommContent = ReadyReaderEcommContent;
const PrimaryProductInfo = (props) => /* @__PURE__ */ React.createElement(ProductDetailStack, { ...props }, /* @__PURE__ */ React.createElement(ProductDetailDescription, { className: "product-detail-stack__description" }, /* @__PURE__ */ React.createElement(ProductDetailFeatures, null)), /* @__PURE__ */ React.createElement(ProductDetailDisclaimer, { className: "product-detail-stack__disclaimer" }), /* @__PURE__ */ React.createElement(ProductDetailDrawerStack, { className: "product-detail-stack__drawer-stack" }, /* @__PURE__ */ React.createElement(ProductDetailSpecification, null), /* @__PURE__ */ React.createElement(ProductDetailManufacturerDrawer, null), /* @__PURE__ */ React.createElement(ProductDetailReviewsDrawer, null)));
const StickyCta = (props) => /* @__PURE__ */ React.createElement(StickyMobileCtaAndPrice, { ...props, cta: /* @__PURE__ */ React.createElement(ReadyReaderCTA, null) });
const SecondaryProductInfo = () => {
  const { Slots: OpcoSlots } = useProductDetailSlots();
  return /* @__PURE__ */ React.createElement(ProductDetailFullWidth, null, /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/row-pdp-container" }), /* @__PURE__ */ React.createElement(FrameMeasurements, null), OpcoSlots.SecondaryProductInfoSlot && /* @__PURE__ */ React.createElement(OpcoSlots.SecondaryProductInfoSlot, null));
};
const ReadyReaderDetailPage = () => {
  return /* @__PURE__ */ React.createElement(EcommFacetProvider, null, /* @__PURE__ */ React.createElement(
    ProductPageLayoutBase,
    {
      EcommContent,
      ImageGallery: ProductImageGallery,
      PrimaryProductInfo,
      StickyCta,
      SecondaryProductInfo
    }
  ));
};
const Page = ({
  facetConfigList,
  ...props
}) => /* @__PURE__ */ React.createElement(ProductPageBase, { ...props, facetConfigList: facetConfigList ?? defaultReadyReaderFacetConfig }, /* @__PURE__ */ React.createElement(ReadyReaderDetailPage, null));
Page.getInitialProps = async (ctx) => {
  const productConfig = await fetchProductConfigBySlug(
    ctx,
    getReadyReaderBySlug,
    mapServerToReadyReaderProduct,
    ctx.pageConfig?.facetConfigList ?? defaultReadyReaderFacetConfig,
    ctx.pageConfig?.flatFacetConfigList ?? defaultReadyReadersFlatFacetConfig
  );
  if ("failure" in productConfig) {
    return handleValidations(productConfig, `Error while initializing Ready Reader PDP`);
  }
  const { product, activeVariant, sku, slug, bloomreachPathOverride } = productConfig;
  return {
    sku,
    slug,
    product,
    activeVariant,
    bloomreachPathOverride
  };
};
export {
  Page
};
//# sourceMappingURL=ready-readers.js.map
